window.UTILS = window.UTILS || { };

window.UTILS.addToCartAnimation = function( source ) {
	var $ = window.jQuery;

  // clone source image and append to body
  var clone = source.clone().addClass( "add-to-cart-animation" ).removeClass( "card-img-top" );
  $( "body" ).append( clone );

  // Get start position
  var sourcePos = source.offset();
  var startX = sourcePos.left + 20;
  var startY = sourcePos.top + 20;

  // Which cart graphics is visible
  var cart;
  var floatCart = $( ".js--basket_info_float-container" );
  if ( floatCart.hasClass( "show" ) ) {
    cart = floatCart;
  } else {
    cart = $( ".mainbar__cartinfo" ); 
  }

  // Get position of visible cart (end anim. position)
  var endPos = cart.offset();
  var endX = endPos.left;
  var endY = endPos.top;

  // Start animation after clone placed to start position
  // Caution: clone css must have some nonzero transition time
  clone.on( "transitionend webkitTransitionEnd" , function() {
    clone.off( "transitionend webkitTransitionEnd" );
    clone.addClass( "flying" );
    clone.css( "transform", "translate(" + endX + "px, " + endY + "px) scale(0.25)" );

    // Remove clone after animation complete
    clone.on( "transitionend webkitTransitionEnd" , function() {
      clone.off( "transitionend webkitTransitionEnd" );
      clone.remove();
    } );
  } );

  // Move clone to start position
  clone.css( "transform", "translate(" + startX + "px, " + startY + "px)" );
};
